import { nonUndefined } from "Utility";
import { FsTournamentSegmentLink } from "db/model/tournament/Segment/FsTournamentSegmentLink";
import { TournamentSegmentLink } from "model/Tournament/Segment/TournamentSegmentLink";

export const mapTournamentSegmentLinks = (
  fsModels: FsTournamentSegmentLink[]
): TournamentSegmentLink[] => {
  return nonUndefined(fsModels.map((s) => mapTournamentSegmentLink(s)));
};

const mapTournamentSegmentLink = (
  fsModel: FsTournamentSegmentLink
): TournamentSegmentLink | undefined => {
  if (!fsModel.name || !fsModel.segmentIds) {
    return undefined;
  }

  return {
    name: fsModel.name,
    segmentIds: fsModel.segmentIds,
  };
};
